export const ROUTE_LOADER_KIND = Object.freeze({
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  TRAIN: 'train',
});

export const ROUTE_LOADER_FULL_HEIGHT = '100vh';

export const ROUTE_SUSPENSE_FALLBACK_SX = Object.freeze({
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FBFBFB',
});
